__turbopack_context__.v({
  "bar": "sAIVsq_bar",
  "bottom": "sAIVsq_bottom",
  "open": "sAIVsq_open",
  "top": "sAIVsq_top",
});
